import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'
import { InputPrefixSuffix } from '../InputPrefixSuffix'

export const InputSuffixWrapper = styled(InputPrefixSuffix)`
  margin-left: ${Spacing.S8};
  padding-left: 0;
`
